import React from 'react';
import { PAYMENT_METHOD_TYPES } from '../consts/consts';
import { GenericPaymentBody } from './GenericPaymentBody';
import { StripeCreditBody } from './StripeCreditBody';

interface IProps {
  method: any;
  handleToggleExpand: () => void;
  triggerReFetchOptionsList: () => void;
}
export const PaymentItemBodySwitch = ({ method, handleToggleExpand, triggerReFetchOptionsList }: IProps) => {
  const getBodyData = () => {
    switch (method.type) {
      case PAYMENT_METHOD_TYPES.STRIPE_CARD:
        return <StripeCreditBody triggerReFetchOptionsList={triggerReFetchOptionsList} method={method} />;
      case PAYMENT_METHOD_TYPES.STRIPE_BANK:
        return <StripeCreditBody triggerReFetchOptionsList={triggerReFetchOptionsList} method={method} />;
      case PAYMENT_METHOD_TYPES.PAYPAL:
        return <GenericPaymentBody triggerReFetchOptionsList={triggerReFetchOptionsList} handleToggleExpand={handleToggleExpand} method={method} />;
      case PAYMENT_METHOD_TYPES.VENMO:
        return <GenericPaymentBody triggerReFetchOptionsList={triggerReFetchOptionsList} handleToggleExpand={handleToggleExpand} method={method} />;
      case PAYMENT_METHOD_TYPES.CASH_APP:
        return <GenericPaymentBody triggerReFetchOptionsList={triggerReFetchOptionsList} handleToggleExpand={handleToggleExpand} method={method} />;
      default:
        return <div className='hidden' />;
    }
  };
  return getBodyData();
};
